import $ from 'jquery'
import _ from 'underscore'
import InviteSeveralUsersLightBox from '../../../js/administration/userManagement/InviteSeveralUsersLightBox'
import InviteSeveralUsersRow from '../../../js/administration/userManagement/InviteSeveralUsersRow'

function APInviteSeveralUsersLightBox(){}

APInviteSeveralUsersLightBox.prototype = _.create(InviteSeveralUsersLightBox.prototype, {
    init: function(inviteUsersData)
    {
        InviteSeveralUsersLightBox.prototype.init.call(this, inviteUsersData);
        return this;
    },

    _generateTable: function()
    {
        this.rows = [];
        var $tableContainer = this.innerContent.find(".tableContainer");
        $tableContainer.empty();
        var $table = $('<table>');
        for (var i = 0; i < this.INITIAL_NUMBER_OF_ROWS; i++)
        {
            this._addRow($table,
                         i,
                         i === 0 ? "firstRow" : (i === this.INITIAL_NUMBER_OF_ROWS - 1 ? "lastRow" : ""));
        }
        $tableContainer.append($table);
    },

    _addEmptyRows: function(number)
    {
        if (this.rows.length + number > 10)
        {
            $(this.lightBoxEl).addClass("scrollable");
        }
        var rowCount = this.rows.length;
        this.rows[rowCount - 1].setSpecialRowClasses("");
        var $table = this.innerContent.find(".tableContainer table");
        for (var i = 0; i < number; i++)
        {
            this._addRow($table,
                         i + rowCount,
                         i == number - 1 ? "lastRow" : "");
        }
        this.updateUI();
    },

    _addRow: function($table, number, specialClass)
    {
        var row = new InviteSeveralUsersRow().init(number,
                                                   specialClass,
                                                   $.proxy(this._validateCallback, this),
                                                   $.proxy(this._changesCallback, this),
                                                   this.errorTooltip);
        this.rows.push(row);
        $table.append(row.getElement());
    }
});

export default APInviteSeveralUsersLightBox



// WEBPACK FOOTER //
// ./web/actiplans/js/administration/APInviteSeveralUsersLightBox.js